import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import LegalFeeModalUI from './LegalFeeModalUI.js'

class LegalFeeModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      feeAmount: '',
      feeAmountError: null,
      reason: '',
      reasonError: null
    }
  }

  render() {
    return (
      <LegalFeeModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        feeAmount={this.state.feeAmount}
        onFeeAmountChange={(event) => { this.setState({ feeAmount: event.target.value }) }}
        feeAmountError={this.state.feeAmountError}
        setFeeAmountError={(error) => { this.setState({ feeAmountError: error }) }}
        //
        reason={this.state.reason}
        onReasonChange={(event) => { this.setState({ reason: event.target.value }) }}
        reasonError={this.state.reasonError}
        setReasonError={(error) => { this.setState({ reasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/legalFees`,
      this.onSubmitCallback, {
      feeAmountF: this.state.feeAmount,
      reason: this.state.reason
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(LegalFeeModalSF)
